import auth from '@/router/auth'
import PromotionIndex from '@/components/class-pros/Index'
import PromotionCreate from '@/components/class-pros/Create'
import PromotionUpdate from '@/components/class-pros/Update'
import PromotionShow from '@/components/class-pros/Show'
import PromotionShowScore from '@/components/class-pros/ShowScoreV2'
import PromotionShowListUser from '@/components/class-pros/ShowListUser'
import PromotionShowPrint from '@/components/class-pros/ShowPrint'
import PromotionShowStudentListPrint from '@/components/class-pros/ShowStudentListPrint'
import PromotionShowStudentPrintTestResult from '@/components/class-pros/showPrintTestResult'

export default [
  {
    path: '/class-pros',
    name: 'class-pros-index',
    component: PromotionIndex,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-pros/create',
    name: 'class-pros-create',
    component: PromotionCreate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-pros/update/:id',
    name: 'class-pros-update',
    component: PromotionUpdate,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-pros/show/:id',
    name: 'class-pros-show',
    component: PromotionShow,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-pros/show/:id/score/:id_class_user',
    name: 'class-pros-show-score',
    component: PromotionShowScore,
    beforeEnter: auth.requireAuth
  },

  {
    path: '/class-pros/show-list-user/:id',
    name: 'class-pros-show-list-user',
    component: PromotionShowListUser,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-pros-note/show/:id/print/:id_class_user',
    name: 'class-pros-show-print',
    component: PromotionShowPrint,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/class-pros-student-list/show/:id',
    name: 'class-pros-show-student-list-print',
    component: PromotionShowStudentListPrint,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/print-test-result/:id/:id_class_user/:id_test_result',
    name: 'print-test-result',
    component: PromotionShowStudentPrintTestResult,
    beforeEnter: auth.requireAuth
  }
]



// WEBPACK FOOTER //
// ./src/components/class-pros/router.js